// Geometry for the Nine Realms gateway.
// The artwork and its hotspots share one "stage" box, so a hotspot can never
// drift off its landmark; this module only decides where that box sits.

const HEADER_H = 56;

const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));

export function realmBounds(realms) {
  const xs = realms.map((r) => r.position.x / 100);
  const ys = realms.map((r) => r.position.y / 100);
  return {
    minX: Math.min(...xs),
    maxX: Math.max(...xs),
    minY: Math.min(...ys),
    maxY: Math.max(...ys),
  };
}

function place(view, size, lo, hi, marginLo, marginHi) {
  let offset = (view - size) / 2;
  if (size >= view) offset = clamp(offset, view - size, 0);
  const minOffset = marginLo - lo * size;
  const maxOffset = view - marginHi - hi * size;
  if (minOffset <= maxOffset) offset = clamp(offset, minOffset, maxOffset);
  return offset;
}

export function computeGatewayLayout(vw, vh, bounds, ratio) {
  if (!vw || !vh) return null;

  const compact = vw < 600;
  const portrait = vh / vw > 1.15;
  const marginX = compact ? 22 : 56;
  const spanX = Math.max(bounds.maxX - bounds.minX, 0.01);
  const spanY = Math.max(bounds.maxY - bounds.minY, 0.01);
  const fitWidthX = (vw - 2 * marginX) / spanX;

  let width;
  let top;
  if (portrait) {
    // Map band under the header, realm list below it.
    width = Math.max(vw, Math.min(fitWidthX, vh * 0.5 * ratio));
    top = HEADER_H;
  } else {
    const marginTop = HEADER_H + 30;
    const marginBottom = compact ? 40 : 64;
    const coverWidth = Math.max(vw, vh * ratio);
    const fitWidthY = ((vh - marginTop - marginBottom) / spanY) * ratio;
    width = Math.min(coverWidth, fitWidthX, fitWidthY);
    top = place(vh, width / ratio, bounds.minY, bounds.maxY, marginTop, marginBottom);
  }

  const height = width / ratio;
  const left = place(vw, width, bounds.minX, bounds.maxX, marginX, marginX);
  const covers = portrait
    ? width >= vw - 0.5
    : left <= 0.5 && top <= 0.5 && left + width >= vw - 0.5 && top + height >= vh - 0.5;

  return { mode: portrait ? 'portrait' : 'landscape', compact, width, height, left, top, covers };
}
